import React, { Component } from 'react';
import md5 from 'md5';
import './Share.css';
import ShareDialog from '../ShareDialog/ShareDialog'
import { text } from 'd3';
import queryString from 'query-string';


const shareUrl = "https://y3egn2mh90.execute-api.ap-southeast-2.amazonaws.com/dev/chrome/"
const articleUrl = "/election_model_vis/"
const shareArticle = "2017-election-forecast"

class Share extends Component {
  constructor(props) {
    super(props);

    this.tweet = this.tweet.bind(this);
    this.share = this.share.bind(this);
    this.screenshot = this.screenshot.bind(this);
    this.twitterCB = this.twitterCB.bind(this);
    this.facebookCB = this.facebookCB.bind(this);
    this.closeShare = this.closeShare.bind(this);
    this.state = {
      loading: false,
      sharing: false 
    }
  }

  closeShare () {

    this.setState({loading: false, sharing: false, page: null, image:null})
  }
  
  screenshot(cb) {
    const { chart,desc,params } = this.props;
    const qs = params ? "?" + queryString.stringify(params) : ""
    const url = articleUrl + qs;
    const now = new Date();
    this.setState({loading: true, sharing: true})
    text(shareUrl + `?url=${window.encodeURIComponent(url)}&article=${shareArticle}&description=${window.encodeURIComponent(desc)}&ts=${window.encodeURIComponent(now)}&chart=${chart}`, f => {
      if (typeof f !== "string") {
        this.screenshot(cb)
      } else {
        this.setState({image: `http://insights.nzherald.co.nz/screenshot/${shareArticle}/${f}.png`
          , page: `http://insights.nzherald.co.nz/screenshot/${shareArticle}/${f}.html`
          , callback: cb
        })
      }
    })
    const filename = md5(url+desc+now);
  }

  facebookCB() {
    const { desc } = this.props;
    const { page } = this.state;
    this.closeShare();
    window.FB.ui({
      method: 'share',
      href: page,
    }, function(response){});

  }

  twitterCB() {
    const { desc } = this.props;
    const { page } = this.state;
    this.closeShare();
    window.open(`https://twitter.com/intent/tweet?url=${page}&text=${window.encodeURIComponent(desc)}&via=nzherald&related=nzherald`)
  }

  tweet() {
    const screenshotUrl = this.screenshot(this.twitterCB);
  }


  nop() {}

  share() {
    const screenshotUrl = this.screenshot(this.facebookCB);
  }


  render() {
    return (
      <div className="share-container cf">
            <div className="share fb" onClick={this.state.loading ? this.nop : this.share}>
              <img src="images/fb-sm-logo.png" />
              <div className={this.state.loading ? "share-loading" : ""}></div>
            </div>
            <div className="share twitter" onClick={this.state.loading ? this.nop : this.tweet} >
              <img  src="images/twitter-sm-logo.png" />
              <div className={this.state.loading ? "share-loading" : ""}></div>
            </div>
         <ShareDialog display={this.state.sharing}
              image={this.state.image}
              page={this.state.page}
              callback={this.state.callback}
              desc={this.props.desc}
              close={this.closeShare}
          />
          </div>
    )}
}

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share/Share.js